import { createContext, useContext } from 'react';
import { RequestKeyBoxMutationActions } from '../../domain';
import { GqlRequestKeyBoxMutationActions } from '../graphql';

type RequestKeyBoxContextT = {
  requestKeyBoxMutationActions: RequestKeyBoxMutationActions;
};

const defaultValue: RequestKeyBoxContextT = {
  requestKeyBoxMutationActions: GqlRequestKeyBoxMutationActions,
};

export const KeyBoxActionsContext = createContext<RequestKeyBoxContextT>(defaultValue);

export const useKeyBoxActions = (): RequestKeyBoxContextT => useContext(KeyBoxActionsContext);
